import useMount from '../../utils/hooks/use-mount';
import { observable } from 'mobx';

/**
 * 使用:
 *  bgmStore = new BGMStore({
 *   localStoreNameSpace: 'bijie_appointment:bg-music'
 * });
 */
class BGMStore {
  /**
   * 音乐播放状态存储在localStorage的标记,例如'bijie_appointment:bg-music'
   */
  @observable localStoreNameSpace;
  /**
   * 是否播放
   * @type {boolean}
   */
  @observable isPlaying = this.getIsPlayingFromLocalStorage();
  /**
   * 网页从后台变为当前时重新播放
   * @type {boolean}
   */
  @observable replayMusicWhenVisibilityChange = false;
  /**
   * 音乐链接
   */
  @observable audioSrc;
  /**
   * 音乐名称
   */
  @observable audioName;
  /**
   * 音乐播放时显示的icon图片地址,例如: require('./images/icon-music.png');
   */
  @observable musicPlayIcon;
  /**
   * 音乐暂停播放时显示的icon图片地址,例如: require('./images/icon-music-pause.png');
   */
  @observable musicPauseIcon;
  /**
   * 音乐icon是否旋转
   * @type {boolean}
   */
  @observable musicIconRotate = true;

  /**
   * 获取暂停/播放状态
   * @returns {boolean}
   */
  getIsPlayingFromLocalStorage = () => {
    const isPlaying = window.localStorage.getItem(this.localStoreNameSpace);
    if (isPlaying === null) {
      return false;
    } else {
      return isPlaying === '1';
    }
  };

  /**
   * 暂停/播放
   * @param isPlaying
   */
  handleChange = isPlaying => {
    if (isPlaying) {
      window.localStorage.setItem(this.localStoreNameSpace, '1');
    } else {
      window.localStorage.setItem(this.localStoreNameSpace, '0');
    }
    this.isPlaying = isPlaying;
  };

  constructor({ ...rest } = {}) {
    Object.assign(this, rest);
  }

  use() {
    useMount(() => {
      this.handleChange(false);
      window.localStorage.setItem(this.localStoreNameSpace, '1');
      window.addEventListener('visibilitychange', e => {
        const isPlaying = this.isPlaying;
        if (document.hidden) {
          // 用于修复手机微信刷新页面也被当做 document.hidden 的场景处理
          setTimeout(() => {
            if (isPlaying) {
              this.handleChange(false);
              this.replayMusicWhenVisibilityChange = true;
            }
          });
        } else {
          if (this.replayMusicWhenVisibilityChange) {
            this.handleChange(true);
            this.replayMusicWhenVisibilityChange = false;
          }
        }
      });
    });
  }
}

export default BGMStore;
